import { mapMutations, mapActions, mapState } from 'vuex';
import { HC_PROPS } from 'lion-vue-src/_globals/routes';

export default {
  data() {
    return {
      showChoiceModal: false,
      eligibility: null, 
    };
  },
  async created() {
    await this.getUserULClients();
  },
  computed: {
    ...mapState('ldAppLayout', ['ulClientLicenses', 'createRelationshipsLicenseSuccess']),
    currentUser() {
      return this.$store.state.userInformation.user;
    },
    isNonCARMLSUser() {
      if (!this.currentUser) return false;
      const nonCARMLSSkus = ['HngTojeR1aC0f2IuR', 'AzyWC9RwRzp7C23sH', 'LIONDESK1327602PLANABC123', 'AzZcjYS2r29CE1ngw', 'LIONDESK1327605PLANABC123']
      return nonCARMLSSkus.includes(this.currentUser.subscriptionOverview.id_chargebee.String);
    }
  },
  methods: {
    ...mapMutations('contact', ['setShowCreateModal']),
    ...mapActions('ldAppLayout', ['getUserULClients', 'createRelationshipLicense']),
    async liondeskCreateContact() {
      this.setShowCreateModal(true);
    },
    async createRelationshipLicenseAndWait() {
      console.log('createRelationshipLicenseAndWait');
      await this.createRelationshipLicense();

      if (!this.createRelationshipsLicenseSuccess) {
        console.log('createRelationshipsLicenseSuccess false');
        return false;
      }

      await new Promise(resolve => setTimeout(resolve, 3000));
      try {
        await this.getUserULClients();
        console.log('getUserULClients');
      } catch (error) {
        console.log('error', error);
        return false;
      }

      return this.ulClientLicenses.includes('Relationships');
    },
    async handleCreateContact() {
      this.eligibility = this.getUserEligibilityChecks();
      const { hasLWAID, isAllowedCohort, isAllowedUser } = this.eligibility;

      console.log('hasLWAID', hasLWAID);
      console.log('isAllowedCohort', isAllowedCohort);
      console.log('isAllowedUser', isAllowedUser);

      if (!isAllowedCohort || !isAllowedUser) {
        console.log('not eligible');
        this.showChoiceModal = false;
        this.liondeskCreateContact();
        return;
      }

      if (!hasLWAID) {
        this.showChoiceModal = true;
        return;
      }

      if (this.ulClientLicenses.includes('Relationships')) {
        console.log('ulClientLicenses.includes(Relationships)');
        this.showChoiceModal = true;
        return;
      } 
      
      const licenseCreated = await this.createRelationshipLicenseAndWait();
      if (licenseCreated) {
        console.log('licenseCreated');
        this.showChoiceModal = true; 
      } else {
        console.log('license not created');
        this.showChoiceModal = false;
        this.liondeskCreateContact(); 
      }
    },
    onCreateContactChoice(option) {
      this.showChoiceModal = false;
      if (option === 'liondesk') {
        this.liondeskCreateContact();
        return;
      }

      // Use cached eligibility if available, otherwise recalculate
      const { hasLWAID, isAllowedCohort, isAllowedUser } = this.eligibility || this.getUserEligibilityChecks();

      if (option === 'relationships' && (!hasLWAID && (isAllowedCohort || isAllowedUser))) {
        window.location.href = `${HC_PROPS.UL_PLATFORM_URL}/authenticate?r=${HC_PROPS.ACCOUNTS_APP_URL}/unified-login?contactModal=true&sc=signup&e=${this.currentUser.email}`;
        return;
      }

      if (option === 'relationships') {
        window.location.href = `${process.env.VUE_APP_RELATIONSHIPS_URL}/contacts/?add-contact=true`;
        return;
      }

      this.liondeskCreateContact();
    },
    getUserEligibilityChecks() {
      if (!this.currentUser) return {
        hasLWAID: false,
        isAllowedCohort: false,
        isAllowedUser: false
      };

      const hasLWAID = !!(this.currentUser.lwa_id && this.currentUser.lwa_id.trim());

      const excludedPlans = ["leads_plus", "leadsplus", "pab"];

      const isPlanExcluded = this.currentUser.subscriptionOverview
        && excludedPlans.includes(this.currentUser.subscriptionOverview.txt_plan);

      let hasLeadsPlusOrPromoteAgentBundleActiveItem = false;
      if (this.currentUser.subscriptionOverview && Array.isArray(this.currentUser.subscriptionOverview.active_items)) {
        hasLeadsPlusOrPromoteAgentBundleActiveItem = this.currentUser.subscriptionOverview.active_items.some(item =>
          item.toLowerCase().includes("leadsplus") || item.toLowerCase().includes("promote-agent-bundle")
        );
      }

      const isAllowedCohort = this.currentUser.subscriptionOverview
        ? !isPlanExcluded && !hasLeadsPlusOrPromoteAgentBundleActiveItem
        : false;

      const isAllowedUser = this.currentUser.subscriptionOverview && this.currentUser.subscriptionOverview.details
        ? (this.currentUser.subscriptionOverview.details.id_user_purchased === this.currentUser.id || this.isNonCARMLSUser) && 
          this.currentUser.role !== "Broker" &&
          this.currentUser.role !== "Subaccount" &&
          !this.currentUser.subscriptionOverview.is_broker &&
          !this.currentUser.subscriptionOverview.is_subaccount &&
          !(this.currentUser.subscriptionOverview.details.id_item && 
            this.currentUser.subscriptionOverview.details.id_item.toLowerCase().includes('broker'))
        : false;
      
      return {
        hasLWAID,
        isAllowedCohort,
        isAllowedUser
      };
    },
  },
}; 